import * as R from "ramda";

import { hasEmptyMap, hasEmptyRooms } from "../selectors";

export const getColumnWarning = step =>
  R.cond([
    [
      R.complement(hasEmptyRooms),
      R.always("Este paso no tiene salas disponibles")
    ],
    [hasEmptyMap, R.always("Este paso no tiene el mapa de chatbot completo")]
  ])(step);
